<template>
  <div class="foot">
    <div class="bqj-home-footer-content">
      <div class="footer-content-left">
        <!-- <div>
          <p @click="aboutAs" style="cursor:pointer">关于我们</p> -->
          <!-- <ul> -->
            <!-- <li @click="aboutAs" style="cursor:pointer">公司简介</li> -->
            <!-- <li>资质荣誉</li>
            <li>发展历程</li>
            <li>服务商登录</li>
            <li>合作伙伴平台</li> -->
          <!-- </ul> -->
        <!-- </div> -->
        <!-- <div> -->
          <!-- <p>常见问题</p> -->
          <!-- <ul> -->
            <!-- <li>投诉建议</li>
            <li>意见反馈</li> -->
            <!-- <li @click="lawLink" style="cursor:pointer">法律声明</li>
          </ul> -->
        <!-- </div> -->
        <div>
          <p>法律声明</p>
          <ul>
            <li @click="lawLink(1)" style="cursor:pointer">时尚知识产权保护平台免责声明</li>
            <li @click="lawLink(2)" style="cursor:pointer">版权预登记及登记业务须知</li>
            <li @click="lawLink(3)" style="cursor:pointer">时尚知识产权保护平台用户注册协议</li>
          </ul>
        </div>
        <div>
          <p>联系我们</p> 
          <ul>
            <li>客服 : 010-84562288-414</li>
            <li>工作时间：周一至周五 9:30-17:30</li>
            <li style="cursor:pointer" @click="linkPerson">在线客服：点击咨询</li>
            <li>商务合作：fashionip@fashion.org.cn</li>
          </ul>
        </div>
      </div>
      <div class="footer-content-right">
          <ul>
              <!-- <li><img src="../../assets/weibo.png"/><span>微博</span></li>
              <li><img src="../../assets/app.png"/><span>下载app</span></li>
              <li><img src="../../assets/wchart.png"/><span>公众平台</span></li> -->
          </ul>
      </div>
    </div>
    <div class="bqj-home-footer-bottom">
      <div class="bqj-homefr">
        <div class="bqj-homefr-center">
          <!--<p>平台服务由北京版全家科技发展有限公司提供</p>-->

            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502042205" style="text-decoration:none;height:20px;line-height:20px;">
              <img src="../../assets/beianico.png" style="float:left;"/>
              <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393; letter-spacing: 1px;">京公网安备 11010502042205号 版权所有©2016-2020 京ICP备20032124号-1</p>
            </a>
          <label style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 15px; color:#939393; font-size: 16px; letter-spacing: 1px;">经营许可证编号：京B2-20202643</label>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import EventBus from "@/libs/eventBus"
  export default {
  name: "homeFooter",
  methods: {
    aboutAs(){
      this.$router.push({name:'aboutUs'})
    },
    lawLink(id){
      this.$router.push({name:'instrument',params: {id:id}})
    },
    linkPerson(){
      EventBus.emit("showContactUs");
    }
  },
  beforeDestroy() {
    EventBus.off('showContactUs');
  },
};
</script>

<style lang="less">
.foot {
  height:394px;
  background:rgba(0,1,6,1);
  min-width: 1334px;
 .bqj-home-footer-content{
    height: 274px;
    clear: both;
    display:flex;
    width:1334px;
    padding-top:42px;
    margin: 0 auto;
    background:rgba(0,1,6,1);
    border-bottom:1px solid rgba(255,255,255,0.1);
    .footer-content-right{
      margin-left:430px;
      ul{
        // margin-top:15px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        li{
          list-style: none;
          display:flex;
          flex-direction: column;
          align-items: center;
          margin-right:40px;
          span{
            margin-top:15px;
            font-size:16px;
            font-weight:400;
            color:rgba(191,191,191,1);
            letter-spacing:2px;
          }
        }
        li:last-child{
          margin-right:0px;
        }
      }
      img{
        width:124px;
        height:124px;
      }
    }
    .footer-content-left{
        display:flex;
        justify-content: flex-start;
        div:first-child{
          margin-right:80px;
        }
        // div:last-child{
        //   margin-left:80px;
        // }
        p{
          height:28px;
          font-size:20px;
          font-weight:400;
          line-height:28px;
          letter-spacing:2px;
          margin-bottom:15px;
          color:rgba(255,255,255,1);
        }
        ul{
            width:100%;
            li{
                height:22px;
                font-size:16px;
                font-weight:400;
                color:rgba(191,191,191,1);
                line-height:22px;
                letter-spacing:2px;
                list-style: none;
                margin-bottom:25px;
                a{
                    color:#fff;
                    cursor:pointer;
                }
            }
        }
    }
 }
 .bqj-home-footer-bottom{
    // border-top:1px solid rgba(255,255,255,0.1);
    height:119px;
    display: flex;
    .bqj-homefr{
        width:1344px;
        margin:0 auto;
        display:flex;
        justify-content: space-between;
        align-items: center;
        p{
          height:22px;
          font-size:16px;
          font-weight:400;
          color:rgba(191,191,191,1);
          line-height:22px;
          letter-spacing:2px;
        }
        .bqj-homefr-left{
          display: flex;
          flex-direction: column;
          p:last-child{
            margin-top:15px;
          }
        }
        .bqj-homefr-center{
          margin: 0 auto;
        }
        .bqj-homefr-right{
          display: flex;
          flex-direction: column;
          text-align: right;
          margin-right:39px;
          p:last-child{
            margin-top:15px;
          }
        }
    }

   .footer_link{
     color: inherit;
     text-decoration: underline;
   }
}
}
</style>
